module.exports = __webpack_public_path__ + "img/diamond-banner.c445a3d5.png";